export default __webpack_public_path__ + "static/media/scarring.eae2bd46.svg";